import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash.debounce';
import { Pressable } from 'react-native';
import Icon from 'LocalGluons/components/Icon';
import { ITEM_TYPES } from 'Utils/index';

import defaultStyles from './Carousel.jss';

const SCROLL_DEBOUNCE_LIMIT = 150;

const WebCarousel = (props) => {
    const elRef = useRef(null);
    const [move, setMove] = useState(0);
    const { items, renderCarousel: Carousel } = props;

    const updateMove = debounce((val) => {
        setMove((i) => i + val);
    }, SCROLL_DEBOUNCE_LIMIT);

    const visibleItems = items[0] && items[0].modelType === ITEM_TYPES.VOD ? 6 : 4;
    return (
        <div ref={elRef} style={{ position: 'relative' }}>
            {move > 0 && (
                <Pressable
                    onPress={() => updateMove(-visibleItems)}
                    style={defaultStyles.leftArrow}
                >
                    <Icon name="arrow_left" />
                </Pressable>
            )}
            {visibleItems + move < items.length && (
                <Pressable
                    onPress={() => updateMove(visibleItems)}
                    style={defaultStyles.rightArrow}
                >
                    <Icon name="arrow_right" />
                </Pressable>
            )}
            <Carousel {...props} scrollIndex={move} />
        </div>
    );
};

WebCarousel.defaultProps = {
    items: []
};

WebCarousel.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({})),
    renderCarousel: PropTypes.func.isRequired
};

export default WebCarousel;
